import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c4da2e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-card" }
const _hoisted_2 = { class: "auth-card__top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "14"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0C1229",
    d: "M21.219 7.761H2.655l4.899 4.912a.78.78 0 0 1 .003 1.099.768.768 0 0 1-1.092.002L.243 7.536a.771.771 0 0 1-.17-.254C.045 7.214.038 7.14.03 7.066c-.003-.028-.017-.053-.017-.082v-.001c0-.104.021-.205.061-.299a.757.757 0 0 1 .13-.197c.014-.016.021-.038.037-.054L6.465.193a.769.769 0 0 1 1.092.003c.3.304.3.796-.003 1.098L2.653 6.207h18.566c.426 0 .772.348.772.777a.775.775 0 0 1-.772.777z"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "auth-card__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'Home' } }, {
        default: _withCtx(() => [
          _createVNode(_component_logo, {
            dark: "",
            class: "auth-card__logo"
          })
        ]),
        _: 1
      }),
      (_ctx.$route.name === 'Verify')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-icon auth-card__back-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
          }, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.title), 1),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}